<template>
  <v-container class="pa-0">
    <v-layout row class="pr-4">
      <span class="display-1 primary--text">Help</span>
    </v-layout>
    <v-divider></v-divider>
    <!-- -------------------------------------Profile ------------------------------------ -->
    <v-card class="my-4">
      <v-card-title class="grey lighten-4 py-0"><span class="title primary--text">Profile</span></v-card-title>
      <v-card-text>
        <v-container fluid class="pa-0" grid-list-lg>
          <v-layout row wrap>
            <v-flex xs12 md4>
              <video height="200px" width="100%" controls>
                <source src="https://s3.ap-south-1.amazonaws.com/ot-tap/help_videos/TAP+profile+final.mp4" type="video/mp4">
              </video>
            </v-flex>
            <v-flex xs12 md8>
              Get started. Refer to this video for steps and assistance to create your custom profile. For further support, contact us.
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
    <!-- -------------------------------------Package ------------------------------------ -->
    <v-card class="my-4">
      <v-card-title class="grey lighten-4 py-0"><span class="title primary--text">Package</span></v-card-title>
      <v-card-text>
        <v-container fluid class="pa-0" grid-list-lg>
          <v-layout row wrap>
            <v-flex xs12 md4>
              <video height="200px" width="100%" controls>
                <source src="https://s3.ap-south-1.amazonaws.com/ot-tap/help_videos/TAP+Packages+Final.mp4" type="video/mp4">
              </video>
            </v-flex>
            <v-flex xs12 md8>
            Package your offerings. Refer to this video for assistance on how to create your packages and provide relevant information and details. For further support, contact us.
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
    <!-- -------------------------------------Calendar ------------------------------------ -->
    <v-card class="my-4">
      <v-card-title class="grey lighten-4 py-0"><span class="title primary--text">Calendar</span></v-card-title>
      <v-card-text>
        <v-container fluid class="pa-0" grid-list-lg>
          <v-layout row wrap>
            <v-flex xs12 md4>
              <video height="200px" width="100%" controls>
                <source src="https://s3.ap-south-1.amazonaws.com/ot-tap/help_videos/TAP+Calender+Final.mp4" type="video/mp4">
              </video>
            </v-flex>
            <v-flex xs12 md8>
              Manage your schedule. Refer to this video to learn how you can effectively manage your training dates and set up your timeline. For further support, contact us.
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
    <!-- -------------------------------------Account ------------------------------------ -->
    <!-- <v-card class="my-4">
      <v-card-title class="grey lighten-4 py-0"><span class="title primary--text">Account</span></v-card-title>
      <v-card-text>
        <v-container fluid class="pa-0" grid-list-lg>
          <v-layout row wrap>
            <v-flex xs4>
              <video height="170px" width="100%" controls>
                <source src="https://s3-us-west-2.amazonaws.com/clearn/video/922e87c2-2a02-4a5d-ad11-14acc6765cba.mp4" type="video/mp4">
              </video>
            </v-flex>
            <v-flex xs8>
              Offsets are useful for compensating for elements that may not be visible yet, or to control the position of content. Just as with breakpoints, you can set an offset for any available sizes. This allows you to fine tune your application layout precisely to your needs.
               you can set an offset for any available sizes. This allows you to fine tune your application layout precisely to your needs.This allows you to fine tune your application layout precisely to your needs.This allows you to fine tune your application layout precisely to your needs.
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card> -->
  </v-container>
</template>
<script>
  export default {
    data () {
      return {
        dialog: false,
        notifications: false,
        sound: true,
        widgets: false
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/Help.vue